import * as Api from "@modules/api";
import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";

import { store } from "../store";
import {
  actions,
  canStartQuizAsync,
  getQuizInstructionsAsync,
  startQuizAsync,
  submitAnswerAsync,
  completeQuizAsync,
  cancelQuizAsync,
  getQuestionsAndAnswersAsync,
  getQuizActionsAsync,
} from "./slices";

export const canStartQuiz = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(canStartQuizAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const getQuizActions = async (
  body: Api.Server.GetContentEntitiesQuizActionInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getQuizActionsAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const clearQuizActions = async () => {
  store.dispatch(actions.clearQuizActions());
};

export const getQuizInstructions = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getQuizInstructionsAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const startQuiz = async (
  body: Api.Server.StartQuizTryInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(startQuizAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const submitAnswer = async (
  body: Api.Server.SubmitAnswerInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(submitAnswerAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const completeQuiz = async (
  body: Api.Server.CompleteQuizTryInput,
  onSuccess?: (
    data: Api.Server.GetQuizResultWithCertificatesOutput
  ) => void | Promise<void>
) => {
  const res = await store.dispatch(completeQuizAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const cancelQuiz = async (
  body: Api.Server.CancelQuizTryInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(cancelQuizAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getQuestionsAndAnswers = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getQuestionsAndAnswersAsync(id));

  return handleDispatchResult(res, onSuccess);
};
